import { useQuery } from '@tanstack/react-query'
import axios, { AxiosHeaders, AxiosResponse, InternalAxiosRequestConfig } from 'axios'
import { UseQueryOptionsWithoutQueryKey } from '../../react-query-config'
import { mapToWeatherCode, WeatherCode } from './weather-code'

type WeatherTodayParams = {
  storeId: number
}

type WeatherToday = {
  weatherCode: WeatherCode
  temperatureMin: number
  temperatureMax: number
}

type WeatherTodayResponse = {
  weather_code: string
  temperature_min: number
  temperature_max: number
}

const QUERY_KEY_WEATHER = 'get-weather-today'

const getWeatherToday = async (config: InternalAxiosRequestConfig): Promise<WeatherToday> => {
  const response: AxiosResponse<WeatherTodayResponse> = await axios(config)
  return {
    weatherCode: mapToWeatherCode(response.data.weather_code),
    temperatureMin: response.data.temperature_min,
    temperatureMax: response.data.temperature_max
  }
}

export const useApiGetWeatherToday = (
  params: WeatherTodayParams,
  options?: UseQueryOptionsWithoutQueryKey<WeatherToday>
) => {
  const url = '/v1/weather/today'
  const config: InternalAxiosRequestConfig = { method: 'get', url, params, headers: new AxiosHeaders() }
  return useQuery<WeatherToday>({
    queryKey: [QUERY_KEY_WEATHER, url, params.storeId],
    queryFn: () => getWeatherToday(config),
    enabled: !!params?.storeId,
    ...options
  })
}
